/**
 * Copyright (C) 2019 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */
import { Component, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

import { SidebarNavItem, } from '@bci-web-core/core';
import { Observable } from 'rxjs';

import { NavigationService } from './_services/navigation.service';
import { ParameterService } from './_services/parameter.service';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { HelpMenuComponent } from './help-menu/help-menu.component';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  private titleService = inject(Title);
  public translate = inject(TranslateService);
  private parService = inject(ParameterService);
  private navigationService = inject(NavigationService);

  // Pfad zu den JSON-Dateien
  sidebarLinks: SidebarNavItem[] = [];
  sidebarFooterLinks: SidebarNavItem[] = [];
  headerItems = [UserMenuComponent,
                 HelpMenuComponent];
  


  constructor() {
    // set language
    this.translate.use(this.parService.language);
    this.translate.addLangs(['en_US', 'de_DE']);
  }

  ngOnInit() {
    this.setApplicationTitle();
    this.getSidebarLinks().subscribe(sidebarLinks => this.sidebarLinks = sidebarLinks);
    this.getSidebarFooterLinks().subscribe(sidebarFooterLinks => this.sidebarFooterLinks = sidebarFooterLinks);
  }

  private setApplicationTitle() {
    this.translate.get('_Title')
        .subscribe(
        data => {
          this.titleService.setTitle(data);
        });
  }

  getSidebarLinks(): Observable<SidebarNavItem[]> {
    return this.navigationService.getNavigationItems();
  }

  getSidebarFooterLinks(): Observable<SidebarNavItem[]> {
    return this.navigationService.getNavigationFooterItems();
  }
}

